import type { Sale } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import { useEffect } from "react";
import useSWRImmutable from "swr/immutable";

import usePromoCode from "./usePromoCode";

const useSale = () => {
	const { userId, isLoaded } = useAuth();
	const {
		data: sale,
		isLoading: isLoadingSale,
		...rest
	} = useSWRImmutable<Sale | null>(userId && `/users/sales/active`, {
		errorRetryCount: 0,
	});

	const { applyPromoCode, isLoadingPromoCode, promoCode } = usePromoCode();

	useEffect(() => {
		if (sale && !isLoadingPromoCode && !promoCode) {
			applyPromoCode(sale.promoCode);
		}
	}, [sale, applyPromoCode, isLoadingPromoCode, promoCode]);

	const handleUpgraded = () => {
		if (!sale) return;
		rest.mutate(
			{
				...sale,
				isAnnualUpgrade: false,
			},
			{},
		);
	};

	return {
		sale,
		isLoadingSale: isLoadingSale || !isLoaded,
		handleUpgraded,
		...rest,
	};
};

export default useSale;
